import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Step {
  label: string
  optional?: boolean
}

interface WizardProgressProps {
  steps: Step[]
  currentStep: number
  className?: string
}

export function WizardProgress({ steps, currentStep, className }: WizardProgressProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      {steps.map((step, index) => {
        const isCompleted = currentStep > index
        const isCurrent = currentStep === index
        const isUpcoming = currentStep < index

        return (
          <div key={index} className="flex items-center flex-1">
            <div className="flex flex-col items-center gap-2">
              <div
                className={cn(
                  'flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all font-mono text-sm font-semibold',
                  isCompleted && 'bg-primary border-primary text-bg',
                  isCurrent && 'border-primary text-primary',
                  isUpcoming && 'border-border text-foreground-muted'
                )}
              >
                {isCompleted ? <Check className="w-5 h-5" /> : index + 1}
              </div>
              <div className="text-center">
                <div
                  className={cn(
                    'text-xs font-mono transition-colors',
                    isCurrent && 'text-primary font-semibold',
                    isCompleted && 'text-foreground',
                    isUpcoming && 'text-foreground-muted'
                  )}
                >
                  {step.label}
                </div>
                {step.optional && (
                  <div className="text-[10px] text-foreground-muted mt-0.5">(facultatif)</div>
                )}
              </div>
            </div>

            {index < steps.length - 1 && (
              <div
                className={cn(
                  'h-0.5 flex-1 mx-3 transition-colors',
                  currentStep > index ? 'bg-primary' : 'bg-border'
                )}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
